
import { Mail } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import ContactSectionForm from "./contact-section/ContactSectionForm";

const Contact = () => {
  const { t } = useLanguage();
  
  return (
    <section id="contact" className="py-20 bg-white dark:bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12 reveal-on-scroll">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 dark:bg-primary/20 mb-6">
            <Mail className="w-8 h-8 text-primary" />
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold mb-4 dark:text-gray-50">{t('contact_title')}</h2>
          <p className="text-lg text-gray-700 dark:text-gray-300 max-w-3xl mx-auto">
            {t('contact_subtitle')}
          </p>
        </div>
        
        <div className="max-w-2xl mx-auto bg-white dark:bg-gray-800 rounded-2xl shadow-subtle p-8 reveal-on-scroll">
          <ContactSectionForm />
        </div>
      </div>
    </section>
  );
};

export default Contact;
